import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { SOCIAL_POSTS } from '../data/mediaAssets';

// Places one or two branded graphics on a product page (matched to the page theme).
const SocialPostBanner = ({ ids = [], className = '' }) => {
  const posts = ids.map((id) => SOCIAL_POSTS.find((p) => p.id === id)).filter(Boolean);
  const [active, setActive] = useState(null);
  if (!posts.length) return null;

  return (
    <div className={`my-12 md:my-16 ${className}`} data-testid="social-post-banner">
      <div className={`grid gap-5 mx-auto ${posts.length > 1 ? 'sm:grid-cols-2 max-w-3xl' : 'max-w-sm'}`}>
        {posts.map((p, i) => (
          <motion.button
            type="button"
            key={p.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08 }}
            onClick={() => setActive(i)}
            className="group relative overflow-hidden rounded-2xl shadow-lg border border-black/5"
            data-testid={`social-banner-${p.id}`}
          >
            <img src={p.src} alt={p.alt} loading="lazy" className="w-full h-auto group-hover:scale-[1.03] transition-transform duration-500" />
          </motion.button>
        ))}
      </div>

      <AnimatePresence>
        {active !== null && (
          <motion.div
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[120] bg-black/90 flex items-center justify-center p-4"
            onClick={() => setActive(null)}
            data-testid="social-banner-lightbox"
          >
            <button onClick={() => setActive(null)} className="absolute top-4 right-4 bg-white/10 hover:bg-white/20 rounded-full p-2" aria-label="Close">
              <X size={24} className="text-white" />
            </button>
            <motion.img
              initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
              src={posts[active].src}
              alt={posts[active].alt}
              className="max-h-[88vh] max-w-[92vw] object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default SocialPostBanner;
